import { render, staticRenderFns } from "./PopupConfirmDeletePage.vue?vue&type=template&id=6c33a1b8"
import script from "./PopupConfirmDeletePage.vue?vue&type=script&lang=js"
export * from "./PopupConfirmDeletePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports